import { LOGOUT_USER, SET_LOGGED_IN_USER } from '../../actions/auth';
import {
  checkIfGiftCardFlowPresent,
  checkIfLimitFlowPresent,
} from '../../helpers';
import { currentFlowTypeEnum } from '../../pages/common/components/constants';

// Resolves the active flow for the selected workspace.
// Gift card is a standalone flow, so it takes precedence over limit/PPI.
const resolveCurrentFlow = applicableFlows => {
  if (checkIfLimitFlowPresent(applicableFlows))
    return currentFlowTypeEnum.FLOW_TYPE_LIMIT;
  if (checkIfGiftCardFlowPresent(applicableFlows))
    return currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD;
  return currentFlowTypeEnum.FLOW_TYPE_PPI;
};

export default function user(state = {}, action = {}) {
  const { type = '', user: userData = {} } = action;

  switch (type) {
    case SET_LOGGED_IN_USER: {
      userData.workspaces = userData.workspaces.reduce((acc, workspace) => {
        acc[workspace.workspace_id] = workspace;
        return acc;
      }, {});

      const [selectedWorkspace] = Object.values(userData.workspaces) ?? {};
      userData.selectedWorkspace = selectedWorkspace;
      // TODO: change this is case of a switch
      userData.currentFlow = resolveCurrentFlow(
        selectedWorkspace?.applicable_flows ?? [],
      );

      const loggedInUserData = userData || {};

      return {
        ...state,
        ...loggedInUserData,
      };
    }

    case LOGOUT_USER:
      return {};

    default:
      return state;
  }
}
